import React from 'react';

const Inicio = () => {
  // Función para abrir WhatsApp con mensaje predefinido
  const handlePresupuesto = () => {
    const telefono = "34640975055"; // Número sin el +
    const mensaje = "Hola, me gustaría solicitar un presupuesto para reparación de mi dispositivo. ¿Podéis informarme?";
    const url = `https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');
  };

  return (
    <div>
      <section className="hero">
        <div className="hero-content">
          <h1>Reparación de móviles en Palafolls<br />tu solución a un clic de distancia</h1>
          <p>¿Tienes problemas con tu móvil o tablet? No busques más.</p>
          <p style={{ fontSize: '1rem', marginBottom: '2rem', color: '#4B5563' }}>
            En Phone Paradise nos especializamos en reparación y venta, ofreciendo un servicio rápido, eficiente y personalizado.
          </p>
          <button className="btn" onClick={handlePresupuesto}>
            Solicitar presupuesto
          </button>
        </div>
      </section>

      <div className="container">
        <div className="section-header">
          <h2>¿Por qué elegirnos?</h2>
          <div className="underline"></div>
        </div>
        
        <div className="card-container">
          <div className="card">
            <img src="https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400" alt="Reparación experta" className="card-image" />
            <div className="card-content">
              <h3>🔧 Expertos multimarca</h3>
              <p>Pantallas rotas, problemas de software, baterías... Nuestro equipo técnico tiene la experiencia para devolver la vida a tu dispositivo. Calidad y rapidez garantizada.</p>
              <p style={{ marginTop: '1rem', color: '#9DD8CC', fontWeight: 500 }}>✨ ¡No te desaceleres!</p>
            </div>
          </div>

          <div className="card">
            <img src="https://images.unsplash.com/photo-1592899677977-9e10cb5889e2?w=400" alt="Variedad de productos" className="card-image" />
            <div className="card-content">
              <h3>🛍️ Dispositivos y accesorios</h3>
              <p>Móviles nuevos y reacondicionados de las mejores marcas. Fundas, protectores, cargadores y más. Todo lo que necesitas en un solo lugar.</p>
              <button className="btn-outline" style={{ marginTop: '1rem', padding: '8px 20px', fontSize: '0.9rem' }}>Ver catálogo</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Inicio;